import React, { Component } from 'react'
import inject from 'helpers/inject'
import AuthService from 'services/auth'

export default function authorized(WrappedComponent) {
  return class extends Component {

    auth = inject(AuthService)

    componentWillMount() {
      if (!this.auth.getIsAuthorized()) {
        this.auth.redirectToAuth()
      }
    }

    render() {
      return <WrappedComponent { ...this.props } />
    }

  }
}



// WEBPACK FOOTER //
// ./src/decorators/authorized.js